(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('valuation-endpoint-client', {
            parent: 'entity',
            url: '/valuation-endpoint-client?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.valuationApiClient.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/valuation-endpoint-client/valuation-endpoint-clients.html',
                    controller: 'ValuationApiClientController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('valuationApiClient');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('valuation-endpoint-client.new', {
            parent: 'valuation-endpoint-client',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/valuation-endpoint-client/valuation-endpoint-client-dialog.html',
                    controller: 'ValuationApiClientDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null,
                                partnerName: null,
                                key: null,
                                enabled: true
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('valuation-endpoint-client', null, { reload: 'valuation-endpoint-client' });
                }, function() {
                    $state.go('valuation-endpoint-client');
                });
            }]
        })
        .state('valuation-endpoint-client.edit', {
            parent: 'valuation-endpoint-client',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/valuation-endpoint-client/valuation-endpoint-client-dialog.html',
                    controller: 'ValuationApiClientDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ValuationApiClient', function(ValuationApiClient) {
                            return ValuationApiClient.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('valuation-endpoint-client', null, { reload: 'valuation-endpoint-client' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('valuation-endpoint-client.delete', {
            parent: 'valuation-endpoint-client',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/valuation-endpoint-client/valuation-endpoint-client-delete-dialog.html',
                    controller: 'ValuationApiClientDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ValuationApiClient', function(ValuationApiClient) {
                            return ValuationApiClient.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('valuation-endpoint-client', null, { reload: 'valuation-endpoint-client' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
